export const tripErrandOptions = [
  {
    label: 'Fundir',
    value: 'Fundir',
  },
  {
    label: 'Námskeið',
    value: 'Námskeið',
  },
  {
    label: 'Ráðstefnur',
    value: 'Ráðstefnur',
  },
  {
    label: 'Vinna erlendis',
    value: 'Vinna erlendis',
  },
  {
    label: 'Annað',
    value: 'Annað',
  },
];

export const countryOptions = [
  { label: 'Austurríki', value: 'Austurríki' },
  { label: 'Bandaríkin', value: 'Bandaríkin' },
  { label: 'Belgía', value: 'Belgía' },
  { label: 'Bermúda', value: 'Bermúda' },
  { label: 'Kanada', value: 'Kanada' },
  { label: 'Sviss', value: 'Sviss' },
  { label: 'Þýskaland', value: 'Þýskaland' },
  { label: 'Danmörk', value: 'Danmörk' },
  { label: 'Spánn', value: 'Spánn' },
  { label: 'Finnland', value: 'Finnland' },
  { label: 'Frakkland', value: 'Frakkland' },
  { label: 'Bretland', value: 'Bretland' },
  { label: 'Georgía', value: 'Georgía' },
  { label: 'Grænland', value: 'Grænland' },
  { label: 'Króatía', value: 'Króatía' },
  { label: 'Ísland', value: 'Ísland' },
  { label: 'Ítalía', value: 'Ítalía' },
  { label: 'Japan', value: 'Japan' },
  { label: 'Mexíkó', value: 'Mexíkó' },
  { label: 'Holland', value: 'Holland' },
  { label: 'Noregur', value: 'Noregur' },
  { label: 'Pólland', value: 'Pólland' },
  { label: 'Portúgal', value: 'Portúgal' },
  { label: 'Svíþjóð', value: 'Svíþjóð' },
  { label: 'Annað', value: 'Annað' },
];

export const timeOptions = [
  {
    label: 'Hvenær sem er dags',
    value: 'Hvenær sem er dags',
  },
  {
    label: 'Morgunn',
    value: 'Morgunn',
  },
  {
    label: 'Hádegi',
    value: 'Hádegi',
  },
  {
    label: 'Eftirmiðdegi',
    value: 'Eftirmiðdegi',
  },
  {
    label: 'Kvöld',
    value: 'Kvöld',
  },
  {
    label: 'Nótt',
    value: 'Nótt',
  },
];
